let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9VBqA")).then(() => parcelRequire('fRfA1'));